module.exports = __webpack_public_path__ + "cf2aabacdc2b3a5768b03545cb1d8330.svg";